module.exports = __webpack_public_path__ + "img/raouls.36bcde14.jpg";